import { useState, FormEvent } from 'react'

interface CreateInviteModalProps {
  onClose: () => void
  onSubmit: (invitee: string) => Promise<void>
}

export function CreateInviteModal({ onClose, onSubmit }: CreateInviteModalProps) {
  const [invitee, setInvitee] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()

    if (!invitee.trim()) {
      setError('Username is required')
      return
    }

    try {
      setLoading(true)
      setError(null)
      await onSubmit(invitee.trim())
    } catch (err) {
      setError('Failed to create invite. Please try again.')
      console.error('Error creating invite:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-bold text-white mb-4">Send Invite</h2>

        {error && (
          <div className="bg-discord-red/20 border border-discord-red rounded p-3 mb-4">
            <p className="text-discord-red text-sm">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="invitee" className="block text-white mb-2">
              Discord Username
            </label>
            <input
              type="text"
              id="invitee"
              value={invitee}
              onChange={(e) => setInvitee(e.target.value)}
              placeholder="username"
              className="w-full px-4 py-2 bg-gray-700 text-white rounded-lg border border-gray-600 focus:outline-none focus:border-discord-blurple"
              disabled={loading}
            />
            <p className="text-discord-gray text-sm mt-1">
              Enter the Discord username (without #discriminator)
            </p>
          </div>

          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-discord-gray hover:text-white transition-colors"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-discord-blurple hover:bg-discord-blurple/80 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Invite'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
